/* eslint-disable */
import Vue from "vue";

export default {
  install() {
    Vue.prototype.$srtToastr = (type, text, title = null) => {
      Vue.prototype.$notify({
        group: "ConveySrtNotification",
        type,
        text,
        title,
        closeOnClick: false,
      });
    };
  }
};
